import Switch from '@mui/material/Switch';
import { styled } from '@mui/material/styles';


export const StyledSwitch = styled(Switch)(({ theme }) => ({
   width: 40,
   height: 20,
   padding: 0,
   margin: '10px 10px 10px 13px',
   display: 'flex',
   '&:active': {
     '& .MuiSwitch-thumb': {
       width: 13, // Wielkość "kropki" w momencie kliknięcia myszką
     },
   },
   '& .MuiSwitch-switchBase': {
     padding: '1px 3px',
     '&.Mui-checked': {
       transform: 'translateX(22spx)', //Druga wartość odpowiada za przesunięcie kropki w pionie
       color: '#fff',
       '& + .MuiSwitch-track': {
         opacity: 1,
         backgroundColor: 'var(--main-app-color)',
       },
     },
   },
   '& .MuiSwitch-thumb': {
     boxShadow: 'none !important',
     width: 13,
     height: 13,
     borderRadius: '50%',
     transform: 'translateY(2px)',
     transition: theme.transitions.create(['width'], {
       duration: 200,
     }),
   },
   '& .MuiSwitch-track': {
     borderRadius: 20 / 2,
     opacity: 1,
     backgroundColor: 'var(--main-aside-text-color)',
     boxSizing: 'border-box',
   },
 }));